module.exports = __webpack_public_path__ + "img/emoSymbols.61f68382.svg";